import React, { useState } from "react";
import ToggleButtons from "./ToggleButton";
import ConfirmModal from "components/common/modals/confirmModal/ConfirmModal";

const ConfirmableToggleButtons = ({
  value,
  onChange,
  buttons,
  showConfirmWhen = false,
  confirmTitle = "Confirm Change",
  confirmMessage = "Are you sure you want to make this change?",
  confirmButtonText = "Confirm",
  cancelButtonText = "Cancel",
  ...rest
}) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const [pendingValue, setPendingValue] = useState(null);

  const handleToggleChange = (event) => {
    const newValue = event.target.value;

    // Support both boolean and function for showConfirmWhen
    const shouldConfirm =
      typeof showConfirmWhen === "function"
        ? showConfirmWhen(newValue)
        : showConfirmWhen;

    if (shouldConfirm) {
      setPendingValue(newValue);
      setShowConfirm(true);
    } else {
      onChange(event);
    }
  };

  const handleConfirm = () => {
    const event = {
      target: {
        value: pendingValue,
      },
    };
    onChange(event);
    setShowConfirm(false);
    setPendingValue(null);
  };

  const handleCancel = () => {
    setShowConfirm(false);
    setPendingValue(null);
  };

  return (
    <>
      <ToggleButtons
        value={value}
        onChange={handleToggleChange}
        buttons={buttons}
        {...rest}
      />

      {showConfirm && (
        <ConfirmModal
          confirmText={confirmButtonText}
          title={confirmTitle}
          show={showConfirm}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
          children={<span>{confirmMessage}</span>}
        />
      )}
    </>
  );
};

export default ConfirmableToggleButtons;
